import * as React from "react"
import { Link } from "gatsby"
import Icon20Years from "../components/icons/Icon20Years"
import IconLocation from "../components/icons/IconLocation"
import IconTools from "../components/icons/IconTools"

const BlockAdvantages = () => {

    return (
        <section className="bg-rekord-lgray advantages">
            <div className="container mx-auto py-16 lg:py-24">
                <div className="grid grid-cols-1 md:grid-cols-3 gap-6 lg:gap-24">
                    <div className="whitespace-normal">
                        <Link className="advantage text-black no-underline" to="/unsere-best-preis-garantie" title="20 Jahre Garantie">
                           <Icon20Years w="40" h="50" />
                           <h3>20 Jahre Garantie</h3>
                           <p>auf Glas, Beschlag & Profil</p>
                        </Link>
                    </div>
                    <div className="advantage whitespace-normal">
                        <IconLocation w="40" h="50" />
                        <h3>Qualität von hier</h3>
                        <p>Nr. 1 als regionaler Produzent Top-Qualität aus Österreich</p>
                    </div>
                    <div className="advantage whitespace-normal">
                        <IconTools w="40" h="50" />
                        <h3>Service kostenlos</h3>
                        <p>Einmalig innerhalb der ersten 2 Jahre</p>
                    </div>
                </div>
             </div>
        </section>
    )

}

export default BlockAdvantages
